/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import { Provider } from "@ethersproject/providers";
import type {
  SmartMoneyWhitelist,
  SmartMoneyWhitelistInterface,
} from "../SmartMoneyWhitelist";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_signer",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "InvalidSignature",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "NotWhitelisted",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "Removed",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        components: [
          {
            internalType: "bool",
            name: "verified",
            type: "bool",
          },
          {
            internalType: "uint8",
            name: "kycType",
            type: "uint8",
          },
          {
            internalType: "uint8",
            name: "countryOfIDIssuance",
            type: "uint8",
          },
          {
            internalType: "uint8",
            name: "countryOfResidence",
            type: "uint8",
          },
          {
            internalType: "bytes32",
            name: "rootHash",
            type: "bytes32",
          },
        ],
        indexed: false,
        internalType: "struct SmartMoneyWhitelist.Credentials",
        name: "credentials",
        type: "tuple",
      },
    ],
    name: "Whitelisted",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "uint8",
        name: "kycType",
        type: "uint8",
      },
      {
        internalType: "uint8",
        name: "countryOfIDIssuance",
        type: "uint8",
      },
      {
        internalType: "uint8",
        name: "countryOfResidence",
        type: "uint8",
      },
      {
        internalType: "bytes32",
        name: "rootHash",
        type: "bytes32",
      },
      {
        internalType: "bytes",
        name: "issuerSignature",
        type: "bytes",
      },
    ],
    name: "addToWhitelist",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "removeFromWhitelist",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "signer",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "whitelist",
    outputs: [
      {
        internalType: "bool",
        name: "verified",
        type: "bool",
      },
      {
        internalType: "uint8",
        name: "kycType",
        type: "uint8",
      },
      {
        internalType: "uint8",
        name: "countryOfIDIssuance",
        type: "uint8",
      },
      {
        internalType: "uint8",
        name: "countryOfResidence",
        type: "uint8",
      },
      {
        internalType: "bytes32",
        name: "rootHash",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

export class SmartMoneyWhitelist__factory {
  static readonly abi = _abi;
  static createInterface(): SmartMoneyWhitelistInterface {
    return new utils.Interface(_abi) as SmartMoneyWhitelistInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): SmartMoneyWhitelist {
    return new Contract(address, _abi, signerOrProvider) as SmartMoneyWhitelist;
  }
}
